module.exports = __webpack_public_path__ + "img/restaurant_3_dine-in.92c51011.jpg";